<template>
  <div class="home">
    <a-row :gutter="[16, 16]">
      <a-col :span="7">
        <DormWidget/>
        <SmallHistory/>
      </a-col>
      <a-col :span="17">
        <a-card :loading="loadingStatistics">
          <a-row :gutter="[8, 8]">
            <a-col :span="6">
              <a-statistic :precision="0" :value="statistics.accountsCount" title="Użytkownicy"/>
            </a-col>
            <a-col :span="6">
              <a-statistic :precision="0" :value="statistics.waitingAccountsCount" title="Oczekujący"/>
            </a-col>
            <a-col :span="6">
              <a-statistic :precision="0" :value="statistics.devicesCount" title="Urządzenia"/>
            </a-col>
            <a-col :span="6">
              <a-statistic :precision="0" :value="statistics.activeLeases">
                <a-tooltip slot="title">
                  <template slot="title">
                    Włącznie z bramą domyślną lokalizacji
                  </template>
                  Przydzielone adresy
                  <a-icon type="question-circle"/>
                </a-tooltip>
              </a-statistic>
            </a-col>
          </a-row>
          <!--          <a-row :gutter="[8, 8]" style="text-align: right; margin-top: 1em">-->
          <!--            <a-col :span="24">-->
          <!--              <a-button type="primary" @click="scriptExecution = true">Przeładuj konfigurację DHCP</a-button>-->
          <!--            </a-col>-->
          <!--          </a-row>-->
        </a-card>

        <a-card style="margin-top: 16px">
          <h2>Oczekujący na aktywację</h2>
          <a-table :columns="columns" :data-source="newJoiners" :loading="loadingWaitingUsersList" :pagination="false"
                   rowKey="accountUuid"
                   size="middle"
                   :locale="{emptyText: 'Brak oczekujących użytkowników...'}"
                   style="border: 1px solid rgba(150, 150, 150, 0.2); border-radius: 6px">
            <template slot="action" slot-scope="record">
              <!--              <a-button v-if="record.accountStatus === 'WAITING' || record.accountStatus === 'DOCUMENT_APPROVED'" :disabled="record.accountStatus === 'WAITING'"-->
              <!--                        size="small" @click="activateAccount(record)">-->
              <!--                {{ record.accountStatus === 'DOCUMENT_APPROVED' ? "Aktywuj" : "Weryfikacja" }}-->
              <!--              </a-button>-->
              <a-button v-if="record.accountStatus === 'WAITING'" size="small" @click="activateAccount(record)">Aktywuj</a-button>
            </template>

            <div slot="dorm" slot-scope="record">
              {{ record.dorm.name }}
            </div>
            <div slot="name" slot-scope="record">{{
                record.accountType !== 'COMMERCIAL' ? `${record.name} ${record.surname}`
                    : record.name
              }}
            </div>
            <div slot="personIdNip" slot-scope="record">
              <a-tooltip v-if="record.personIdValidation && record.accountType !== 'COMMERCIAL'">
                <template slot="title">
                  {{
                    personIdVerificationDictionary[record.personIdValidation.result].text ? personIdVerificationDictionary[record.personIdValidation.result].text : 'Brak danych'
                  }}
                </template>
                <a-icon
                    :type="personIdVerificationDictionary[record.personIdValidation.result].icon"
                    theme="twoTone"
                    :two-tone-color="personIdVerificationDictionary[record.personIdValidation.result].color"/>
              </a-tooltip>
              {{
                (record.accountType !== 'COMMERCIAL' ? record.personId :
                    `${record.nip ? `NIP: ${record.nip}` : '-'}`).toUpperCase()
              }}
            </div>
            <div slot="created" slot-scope="record">
              {{ new Date(record.created) | moment('HH:mm - DD.MM.YYYY') }} r.
            </div>
            <div slot="expandedRowRender" slot-scope="record">
              <div class="table-details">
                <div v-if="record.homeAddress" style="margin-bottom: 0.5em">
                  <small style="font-weight: 700; color: #101010">Adres zameldowania</small><br/>
                  {{ record.homeAddress ? record.homeAddress : '- brak -' }}
                </div>
                <div v-if="record.university" style="margin-bottom: 0.5em">
                  <small style="font-weight: 700; color: #101010">Szkoła/Uczelnia</small><br/>
                  {{ record.university ? record.university : '- brak -' }}
                </div>
                <div v-if="record.faculty" style="margin-bottom: 0.5em">
                  <small style="font-weight: 700; color: #101010">Kierunek/Specjalizacja</small><br/>
                  {{ record.faculty ? record.faculty : '- brak -' }}
                </div>
                <div v-if="record.semester" style="margin-bottom: 0.5em">
                  <small style="font-weight: 700; color: #101010">Semestr</small><br/>
                  {{ record.semester ? record.semester : '- brak -' }}
                </div>
                <div v-if="record.emailAddress" style="margin-bottom: 0.5em">
                  <small style="font-weight: 700; color: #101010">Adres e-mail</small><br/>
                  {{ record.emailAddress ? record.emailAddress : '- brak -' }}
                </div>
                <div style="margin-bottom: 0.5em; text-align: right;">
                  <a-button icon="user" type="primary"
                            @click="goTo({ name: 'User', params: { uuid: record.accountUuid } })">
                    Pokaż profil
                  </a-button>
                </div>
              </div>
            </div>
            <a-row slot="footer">
              <a-col :span="16">
                <a-progress :percent="0" :show-info="false" size="small" style="margin-top: 6px"/>
              </a-col>
              <a-col :span="8" style="text-align: right">
                <a-button type="primary" :disabled="!usersCountChanged" @click="getWaitingUsers">Odśwież listę
                  {{ usersCountActual > 0 ? `(${usersCountActual})` : '' }}
                </a-button>
              </a-col>
            </a-row>
          </a-table>
        </a-card>

        <IssuesCard />
      </a-col>
    </a-row>
    <a-modal
        :visible="scriptExecution"
        title="Skrypt"
        :maskClosable="false"
        :closable="true"
        :keyboard="true"
        :width="'90%'"
        :footer="null"
        @ok="handleCloseScript"
        @cancel="handleCloseScript">
      <div v-for="dorm in nodes" :key="dorm.id">
        <h3 style="margin-top: 1em">{{ dorm.name }}</h3>
        <DormPipeline v-if="scriptExecution" :script="'leases'" :dorm="dorm.code"/>
      </div>
    </a-modal>
  </div>
</template>

<script>
import httpClient from "../utils/httpClient";
import SmallHistory from "@/components/history/SmallHistory.vue";
import DormWidget from "@/components/dorm/DormWidget.vue";
import DormPipeline from "@/components/dorm/DormPipeline.vue";
import moment from "moment";
import IssuesCard from "@/components/issue/IssuesCard.vue";

const columns = [
  {title: 'Imię i nazwisko', key: 'name', scopedSlots: {customRender: 'name'}},
  {title: 'PESEL/Paszport', key: 'personId', scopedSlots: {customRender: 'personIdNip'}},
  {title: 'Lokalizacja', key: 'dorm', scopedSlots: {customRender: 'dorm'}},
  {title: 'Pomieszczenie', dataIndex: 'room', key: 'room'},
  {title: 'Państwo', dataIndex: 'country', key: 'country'},
  {title: 'Data utworzenia', key: 'created', scopedSlots: {customRender: 'created'}},
  {
    title: '',
    key: 'operation',
    scopedSlots: {customRender: 'action'},
  },
];


const personIdVerificationDictionary = {
  "VALID_PESEL": {
    "color": "#52c41a",
    "text": "Numer PESEL poprawny",
    "icon": "check-circle",
  },
  "VALID_PASSPORT": {
    "color": "#52c41a",
    "text": "Numer paszportu poprawny",
    "icon": "check-circle",
  },
  "INVALID_PESEL_FORMAT": {
    "color": "#faad14",
    "text": "Niepoprawny format numeru PESEL",
    "icon": "warning",
  },
  "INVALID_PASSPORT_FORMAT": {
    "color": "#faad14",
    "text": "Niepoprawny format numeru paszportu",
    "icon": "warning",
  },
  "INVALID_PESEL_DATE": {
    "color": "#f5222d",
    "text": "Niepoprawna data urodzenia",
    "icon": "exclamation-circle",
  },
  "INVALID_PESEL_CHECKSUM": {
    "color": "#f5222d",
    "text": "Niepoprawna suma kontrolna numeru PESEL",
    "icon": "exclamation-circle",
  },
  "INVALID_FORMAT": {
    "color": "#faad14",
    "text": "Niepoprawny format",
    "icon": "warning",
  }
}

export default {
  name: "Home",
  data() {
    return {
      columns,
      personIdVerificationDictionary,
      usersCount: null,
      usersCountActual: 0,
      usersCountChanged: false,
      newJoiners: [],
      newsList: [],
      loadingStatistics: true,
      statistics: {
        accountsCount: 0,
        waitingAccountsCount: 0,
        devicesCount: 0,
        activeLeases: 0,
      },
      scriptExecution: false,
      data: [],
      nodes: [
        {
          id: 1,
          name: "D.S. Asystent",
          code: "ds-asystent",
          description: "81.26.6.4",
          status: "processing",
          tags: [
            {
              name: "Aktualizacja",
              color: "cyan"
            }
          ],
          statusGraph: ['error', 'problem', 'problem', 'active', 'active', 'active', 'active', 'active', 'active', 'active', 'active', 'active']
        },
        {
          id: 2,
          name: "D.S. Bartek",
          code: "ds-bartek",
          status: "success",
          tags: [],
          statusGraph: ['active', 'active', 'active', 'active', 'active', 'active', 'active', 'active', 'active', 'active', 'active', 'active']
        },
        {
          id: 3,
          name: "D.S. Filon",
          code: "ds-filon",
          status: "success",
          tags: [],
          statusGraph: ['active', 'active', 'active', 'active', 'active', 'active', 'active', 'active', 'problem', 'active', 'active', 'active']
        },
        {
          id: 4,
          name: "D.S. Laura",
          code: "ds-laura",
          status: "success",
          tags: [],
          statusGraph: ['active', 'active', 'active', 'active', 'active', 'active', 'active', 'active', 'active', 'active', 'active', 'active']
        },
        {
          id: 5,
          name: "D.S. Mimoza",
          code: "ds-mimoza",
          status: "success",
          tags: [
            {
              name: "Brak miejsca na dysku",
              color: "red"
            },
            {
              name: "Uszkodzony dysk",
              color: "orange"
            }
          ],
          statusGraph: ['active', 'active', 'active', 'active', 'active', 'active', 'active', 'active', 'active', 'active', 'active', 'active']
        },
        {
          id: 6,
          name: "D.S. Proton",
          code: "ds-proton",
          status: "success",
          tags: [],
          statusGraph: ['active', 'active', 'active', 'active', 'active', 'active', 'active', 'active', 'active', 'active', 'active', 'active']
        }
      ],
      loadingWaitingUsersList: true,
    };
  },
  components: {
    IssuesCard,
    DormPipeline,
    SmallHistory,
    DormWidget
  },
  mounted() {
    this.getWaitingUsers()
    this.getStatistics()
    this.$emit("loadedView");
    setInterval(() => {
      this.getWaitingUsersStatus()
      this.getStatistics()
    }, 30000)
  },
  computed: {
    moment() {
      return moment
    },
    computedSession() {
      return this.$store.getters.getUserConnectionDetails;
    },
  },
  methods: {
    getWaitingUsers() {
      this.loadingWaitingUsersList = true;
      httpClient
          .get("/admin/accounts/waiting?size=100&page=0")
          .then((response) => {
            this.newJoiners = response.payload;
            this.usersCount = response.page.total
          }).catch((error) => {
        if (error.response.status !== 401) {
          this.$message.error("Wystąpił błąd wczytywania")
        }
      }).finally(() => {
        this.loadingWaitingUsersList = false;
      });
    },

    getWaitingUsersStatus() {
      httpClient
          .get("/admin/accounts/waiting?size=1&page=0")
          .then((response) => {
            if (this.usersCount !== null) {
              this.usersCountChanged = this.usersCount !== response.page.total
              this.usersCountActual = response.page.total - this.usersCount

              if (this.usersCount === 0 && this.usersCountActual > 0) {
                this.getWaitingUsers()
              }
            } else {
              this.usersCount = response.page.total
            }
          })
    },

    getStatistics() {
      httpClient
          .get("/utils/statistics")
          .then((response) => {
            this.statistics = response;
          }).catch((error) => {
        if (error.response.status !== 401) {
          this.$message.error("Wystąpił błąd wczytywania statystyk")
        }
      }).finally(() => {
        this.loadingStatistics = false;
      });
    },

    activateAccount(account) {
      this.$message.loading({content: `Aktywowanie konta ${account.name} ${account.surname}...`, key: 'activate'});
      httpClient
          .put(`/admin/accounts/details/${account.accountUuid}/activate-with-devices`)
          .then(() => {
            this.newJoiners.findLast((item) => item.accountUuid === account.accountUuid).accountStatus = 'ACTIVE'
            this.$message.success({content: `Konto ${account.name} ${account.surname} zostało aktywowane!`, key: 'activate'});
          }).catch((error) => {
        if (error.response.status !== 401) {
          this.$message.error({content: `Wystąpił błąd z aktywacją ${account.name} ${account.surname}!`, key: 'activate'});
        }
      })
    },

    handleCloseScript() {
      this.scriptExecution = false;
    },

    goTo(obj) {
      if (this.$route.name !== obj.name) {
        this.$router.push(obj);
      }
    },
  },
};
</script>

<style scoped>
.header {
  background: rgb(0, 33, 61);
  background: linear-gradient(120deg, rgba(0, 22, 40, 1) 5%, rgba(25, 144, 255, 1) 200%);
  padding: 2vh 5vw;
}

@media screen and (min-width: 992px) {
  .header {
    background: rgb(0, 33, 61);
    background: linear-gradient(120deg, rgba(0, 22, 40, 1) 10%, rgba(25, 144, 255, 1) 120%);
    padding: 1vh 10vw;
  }
}

.header-text {
  font-size: 3em;
  color: #ffffff;
  text-shadow: 1px 1px 0px rgba(0, 0, 75, 1),
  2px 2px 0px rgba(0, 0, 75, 1),
  3px 3px 0px rgba(0, 0, 75, 1),
  4px 4px 0px rgba(0, 0, 75, 1),
  5px 5px 0px rgba(0, 0, 75, 1);
}

.sub-header-text {
  color: #ffffff;
  text-shadow: 1px 1px 0px rgba(0, 0, 75, 1),
  2px 2px 0px rgba(0, 0, 75, 1),
  3px 3px 0px rgba(0, 0, 75, 1);
}

.table-details {
  background-color: rgba(200, 200, 200, 0.1);
  padding: 0.5em 1em;
  margin-right: 4px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 6px;
}
</style>
